<template>   
    <div class="unifiAccountContainer">
      <div class="stack spreadApart fullHeight">
        <div class="flexible shelfCenter">
          <div class="unifiAccount">
            <div class="unifiAccount__unifiLogo icon ubnt-icon--unifi"><img max-width="350px" alt="" style="max-height:120px;" :src="logoPath"></div>

            <div v-if="(meta_data.enableOtpOption == 'yes' || meta_data.adminOtpOption=='bothUsernameAndOtp' || meta_data.adminOtpOption=='onlyOtp') && (meta_data.adminUrlOtpshow == 'true')">
              
              <div class="unifiLogin ubnt-mod-dark">
                <ul style=" height:100px;" class="appTabs appTabs--cozy appTabs--flexible" pageutils-nav-active-class="is-tab-selected">
                  <li v-if="meta_data.adminOtpOption == 'bothUsernameAndOtp'" style=" height:50px;" @click="selectedTab='normalLogin'" class="tabs__item" :class="{'is-tab-selected':selectedTab == 'normalLogin'}">
                    <span style="font-size:15px; font-family:Sans-serif; position:relative; top:20px;">Login</span>
                  </li>
                  <li  v-if="meta_data.adminOtpOption == 'bothUsernameAndOtp' || meta_data.adminOtpOption=='onlyOtp' " style=" height:50px;" @click="selectedTab='otpLogin'" class="tabs__item" :class="{'is-tab-selected':selectedTab == 'otpLogin'}">
                    <span style="font-size:15px; font-family:Sans-serif; position:relative; top:20px;">OTP Login</span>
                  </li>
                </ul>
              </div>

              <div  class="unifiAccount__content" v-if="selectedTab == 'normalLogin' && meta_data.adminOtpOption=='bothUsernameAndOtp'">
                <div class="unifiLogin ubnt-mod-dark" style="position:relative; top:-40px;">
                  <form class="appForm appForm--dark is-validation-hidden" :class="formClass" name="loginCtrl.form">
                    <div class="jazeAlert jazeAlert--danger row col-12" v-show='errorShow'>
                      <div class="col-12">
                        <strong v-html="errorMessage"></strong>
                      </div>
                    </div>
                    <div class="appFormGroup"><label class="appLabel appLabel--primary unweighted" translate="ACCOUNT_LOGIN_LABEL_USERNAME">Username</label><input class="input--full ng-pristine ng-empty ng-invalid ng-invalid-required ng-touched" type="text" v-model='username' name="username" ng-model="loginCtrl.username" required autocapitalize="off" autocorrect="off" autofocus=""></div>
                    <div class="appFormGroup"><label class="appLabel appLabel--primary unweighted" translate="ACCOUNT_LOGIN_LABEL_PASSWORD">Password</label><input class="input--full ng-pristine ng-untouched ng-empty ng-invalid ng-invalid-required" type="password" v-model='password' name="password" ng-model="loginCtrl.password" required></div>

                    <div class="verticalRhythmTop--cozy"><button type="submit" class="appMainButton appMainButton--primary appMainButton--full busyToggle" busy-toggle="loginCtrl.isSubmitting" busy-toggle-spinner-classes="['appSpinner', 'appSpinner--light', 'appSpinner--centered']" translate="ACCOUNT_LOGIN_ACTIONS_SIGN_IN" @click='onSubmit'>Sign In</button></div>
                    <div class="verticalRhythmTop--cozy"><a class="appMainButton appMainButton--transparentDark appMainButton--full" ui-sref="manage.account.forgotpassword" unifi-if-app="['app-unifi-manage', 'app-unifi-overview']" translate="ACCOUNT_LOGIN_LINK_FORGOT_PASSWORD">
                        <router-link :to="{ path: '/reset_password'}">Forgot password?</router-link>
                      </a></div>
                    <div class="appMainButton appMainButton--transparentDark appMainButton--full"> <a  class="jazeLink ">  <router-link target="_blank" :to="{ path: '/terms'}">Terms of Service</router-link></a>&nbsp; and &nbsp; <a class="jazeLink" ><router-link target="_blank" :to="{ path: '/privacy_policy'}">Privacy Policy</router-link> </a></div>
                  </form>
                </div>
              </div>
              <div v-if="selectedTab == 'otpLogin' || meta_data.adminOtpOption=='onlyOtp' ">
                <div class="unifiAccount__content" style="position:relative; top:-60px;">
                  <div class="unifiLogin ubnt-mod-dark">
                    <form class="appForm appForm--dark is-validation-hidden" :class="formClass" name="loginCtrl.form">
                      <div class="jazeAlert jazeAlert--danger row col-12" v-if='errorShow'>
                        <div class="col-6">
                          <strong>{{errorMessage}}</strong>
                        </div>
                      </div>
                      <div v-if="otpEnable != 'success'" class="appFormGroup"><label class="appLabel appLabel--primary unweighted" translate="ACCOUNT_LOGIN_LABEL_PASSWORD">Mobile Number</label><input class="input--full ng-pristine ng-empty ng-invalid ng-invalid-required ng-touched" type="text" v-model='mobile' name="mobile" ng-model="loginCtrl.mobile" required autocapitalize="off" autocorrect="off" autofocus=""></div>
                      <div v-if="otpEnable != 'success'" class="appFormGroup"><label class="appLabel appLabel--primary unweighted">Username(optional)</label><input class="input--full ng-pristine ng-untouched ng-empty ng-invalid ng-invalid-required" type="text" v-model='usernameAdminOtp' name="usernameAdminOtp" ng-model="loginCtrl.usernameAdminOtp" ></div>
                      <div v-if="otpEnable == 'success'" class="appFormGroup"><label class="appLabel appLabel--primary unweighted">Enter OTP</label><input class="input--full ng-pristine ng-empty ng-invalid ng-invalid-required ng-touched" type="text" v-model='otp' name="otp" ng-model="loginCtrl.otp" required autocapitalize="off" autocorrect="off" autofocus=""></div>
                      <div v-if="otpEnable != 'success'" class="verticalRhythmTop--cozy"><button type="submit" class="appMainButton appMainButton--primary appMainButton--full busyToggle" busy-toggle="loginCtrl.isSubmitting" busy-toggle-spinner-classes="['appSpinner', 'appSpinner--light', 'appSpinner--centered']" translate="ACCOUNT_LOGIN_ACTIONS_SIGN_IN" @click="otpTabEnable">SEND OTP</button></div>
                      <div v-if="otpEnable == 'success'" class="verticalRhythmTop--cozy"><button type="submit" class="appMainButton appMainButton--primary appMainButton--full busyToggle" busy-toggle="loginCtrl.isSubmitting" busy-toggle-spinner-classes="['appSpinner', 'appSpinner--light', 'appSpinner--centered']" translate="ACCOUNT_LOGIN_ACTIONS_SIGN_IN" @click="adminOtpsubmit">VERIFY</button></div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
        
      
            <div  class="unifiAccount__content" v-if=" meta_data.enableOtpOption == 'no' || meta_data.adminOtpOption=='onlyAdminUsername' || meta_data.adminUrlOtpshow == 'false'">  
              <div class="unifiLogin ubnt-mod-dark" >
                <form class="appForm appForm--dark is-validation-hidden" :class="formClass" name="loginCtrl.form">
                  <div class="jazeAlert jazeAlert--danger row col-12" v-show='errorShow'>
                    <div class="col-12">
                      <strong v-html="errorMessage"></strong>
                    </div>
                  </div>
                  <div class="appFormGroup"><label class="appLabel appLabel--primary unweighted" translate="ACCOUNT_LOGIN_LABEL_USERNAME">Username</label><input class="input--full ng-pristine ng-empty ng-invalid ng-invalid-required ng-touched" type="text" v-model='username' name="username" ng-model="loginCtrl.username" required autocapitalize="off" autocorrect="off" autofocus=""></div>
                  <div class="appFormGroup"><label class="appLabel appLabel--primary unweighted" translate="ACCOUNT_LOGIN_LABEL_PASSWORD">Password</label><input class="input--full ng-pristine ng-untouched ng-empty ng-invalid ng-invalid-required" type="password" v-model='password' name="password" ng-model="loginCtrl.password" required></div>

                  <div class="verticalRhythmTop--cozy"><button type="submit" class="appMainButton appMainButton--primary appMainButton--full busyToggle" busy-toggle="loginCtrl.isSubmitting" busy-toggle-spinner-classes="['appSpinner', 'appSpinner--light', 'appSpinner--centered']" translate="ACCOUNT_LOGIN_ACTIONS_SIGN_IN" @click='onSubmit'>Sign In</button></div>
                  <div class="verticalRhythmTop--cozy"><a class="appMainButton appMainButton--transparentDark appMainButton--full" ui-sref="manage.account.forgotpassword" unifi-if-app="['app-unifi-manage', 'app-unifi-overview']" translate="ACCOUNT_LOGIN_LINK_FORGOT_PASSWORD">
                      <router-link :to="{ path: '/reset_password'}">Forgot password?</router-link>
                    </a></div>
                    <div class="appMainButton appMainButton--transparentDark appMainButton--full"> <a  class="jazeLink ">  <router-link target="_blank" :to="{ path: '/terms'}">Terms of Service</router-link></a>&nbsp; and &nbsp; <a class="jazeLink" ><router-link target="_blank" :to="{ path: '/privacy_policy'}">Privacy Policy</router-link> </a></div>
                </form>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
</template>
<script>
import axios from "@/api/index";
import qs from "qs";
import { useloginStore } from '@/store/loginstore';
export default {
  setup() {
    const loginStore = useloginStore()
    return { loginStore }
  },
  // components: {
  //   AdminOtpLogin,
  // },

  data() {
    return {
      username: "",
      password: "",
      errorShow: false,
      errorMessage: "",
      formClass: "",
      logoPath: "",
      meta_data: [],
      selectedTab: "normalLogin",
      otp: "",
      usernameAdminOtp: "",
      mobile: "",
      otpEnable: "",
      adminUsername: "",
      adminMessage: "",
      paymentAlert: "",
      resellerPayment: "",
      expirationDataExp: "",
    };
  },
  mounted() {
    this.getSignInLogo();
  },
  methods: {
    getSignInLogo() {
      axios
        .get("/login/get_signin_logo")
        .then((response) => {
          if (response.data.message.includes("http")) {
            this.logoPath = response.data.message;
          } else {
            this.logoPath = "/backend" + response.data.message;
          }
          this.meta_data = response.data.meta_data;
          if(this.meta_data.adminOtpOption=='onlyOtp'){
            this.selectedTab = "otpLogin";
          }
          const favicon = document.getElementById("favicon");
          if (this.meta_data.favicon_url.includes("http")) {
            favicon.href = this.meta_data.favicon_url;
          } else {
            favicon.href = "/backend" + this.meta_data.favicon_url;
          }

          if (response.data.meta_data != undefined) {
            document.title = response.data.meta_data.title + " : " + "Login";
          }
          if (response.data.redirectUrl["url"] == "/register") {
            this.$router.push("/register");
          } else {
            this.$router.push("/signin");
          }
        })
        .catch((error) => console.log(error));
    },
    onSubmit(e) {
      e.preventDefault();
      if (!this.username) {
        this.formClass = "is-form-validation-visible";
        return;
      }
      if (!this.password) {
        this.formClass = "is-form-validation-visible";
        return;
      }
      const formData = {
        username: this.username,
        password: this.password,
      };
      // this.$store
      //   .dispatch("findLogin", {
      //     username: formData.username,
      //     password: formData.password,
      //   })
      //   .then(
      this.loginStore.findLogin(
        {
          username: formData.username,
          password: formData.password,
        }
      ).then(
          (response) => {
            if (response.status == "success") {
              this.$router.push("/dashboard");
            }
          },
          (error) => {
            this.errorShow = true;
            this.errorMessage = error;
            console.log(error);
          }
        );
    },

    otpTabEnable(e) {
      e.preventDefault();
      var postData = {
        username: this.usernameAdminOtp,
        mobile: this.mobile,
      };
      axios
        .post(
          "/login/admin_otp_login",
          qs.stringify(postData, {
            parseArrays: false,
          })
        )
        .then((response) => {
          this.otpEnable = response.data.status;
          this.adminMessage = response.data.adminMessage;
          this.paymentAlert = response.data.paymentAlert;
          this.resellerPayment = response.data.resellerPayment;
          this.expirationDataExp = response.data.expirationDataExp;
          if (this.otpEnable == "error") {
            this.errorShow = true;
            this.errorMessage = response.data.message;
            console.log("error");
          }
          setTimeout(
            function () {
              this.errorShow = false;
            }.bind(this),
            2000
          );
        });
    },

     adminOtpsubmit(e) {
      e.preventDefault();
      var data = {
        otp: this.otp,
      };
      axios
        .post(
          "/login/admin_otp_submit",
          qs.stringify(data, {
            parseArrays: false,
          })
        )
        .then((response) => {
          if (response.data.status == "success") {
            const formData = {
              adminMessage: this.adminMessage, 
              paymentAlert: this.paymentAlert, 
              resellerPayment: this.resellerPayment, 
              expirationDataExp: this.expirationDataExp, 
            };
            
            // this.$store
            //   .dispatch("findAdminOtpLogin", {
            //     adminMessage: formData.adminMessage,
            //     paymentAlert: formData.paymentAlert,
            //     resellerPayment: formData.resellerPayment,
            //     expirationDataExp: formData.expirationDataExp,
            //   })
            //   .then(
            this.loginStore.findAdminOtpLogin(
              {
                adminMessage: formData.adminMessage,
                paymentAlert: formData.paymentAlert,
                resellerPayment: formData.resellerPayment,
                expirationDataExp: formData.expirationDataExp,
              }
            ).then(
                (response) => {
                  if (response.status == "success") {
                    this.$router.push("/dashboard");
                  }
                },
                (error) => {
                  this.errorShow = true;
                  this.errorMessage = error;
                  console.log(error);
                }
              );
          } else {
            this.errorShow = true;
            this.errorMessage = response.data.message;
          }
          setTimeout(
            function () {
              this.errorShow = false;
            }.bind(this),
            2000
          );
        });
    },
  },
};
</script>
